import React from "react";
import { CheckboxField, SubHead } from "@/components/wizard/Fields";

const BUSINESS = "Rehoboth Wealth Group";

export function DisclaimerSection({ variant = "will", value = {}, onChange }) {
  const set = (k, v) => onChange({ ...value, [k]: v });
  return (
    <div>
      <SubHead>Cooling-off waiver</SubHead>
      <p className="text-sm text-brand-muted leading-relaxed mb-2">
        We will not begin work until after the 14-day cooling-off period has expired unless you ask us to start now.
        The 14-day period begins on the day this agreement is entered into. If you ask us to start work during the
        cooling-off period you still have the right to cancel within 14 days, but you agree to pay for any work
        completed up to the point we receive your cancellation. If the agreed services are fully completed within the
        cooling-off period at your request, no refund will be payable if you later choose to cancel.
      </p>
      <CheckboxField label="I wish work to start immediately and waive the cooling-off period."
        checked={value.coolingOffWaiver} onChange={(v) => set("coolingOffWaiver", v)} testId="disc-cooling-off" />

      {variant === "will" && (
        <>
          <SubHead>Professional Executorship Service</SubHead>
          <p className="text-sm text-brand-muted leading-relaxed mb-2">
            You may ask us to act as professional executors under your Will. {BUSINESS} will manage the administration of
            your estate and the distribution of assets to your beneficiaries. Our probate fees are fixed at 1.95% of the
            gross estate value plus VAT, disbursements and third-party costs if any (typical UK probate fees range from 2%
            to 10%).
          </p>
          <CheckboxField label={`I wish to appoint ${BUSINESS} to act as professional executors on the terms outlined above.`}
            checked={value.professionalExecutorship} onChange={(v) => set("professionalExecutorship", v)} testId="disc-prof-exec" />
        </>
      )}

      {variant === "lpa" && (
        <>
          <SubHead>Lasting Power of Attorney — registration</SubHead>
          <p className="text-sm text-brand-muted leading-relaxed mb-2">
            We will prepare the relevant LPA documentation within approximately 4–8 weeks. LPAs cannot be created after
            mental capacity is lost. Registration with the Office of the Public Guardian (OPG) is required before the
            documents can be used and is therefore recommended. The current OPG fee is £92 per document, payable directly
            to the OPG and not included in our fees. It is possible in certain circumstances to obtain a reduction or
            omission of these fees if you meet the criteria.
          </p>
          <CheckboxField label="I confirm I have read and understood the LPA registration information above."
            checked={value.lpaRegistrationAck} onChange={(v) => set("lpaRegistrationAck", v)} testId="disc-lpa-ack" />
        </>
      )}

      <SubHead>Secure storage service</SubHead>
      <p className="text-sm text-brand-muted leading-relaxed mb-2">
        We offer secure document storage to help ensure your estate planning documents are kept safely and remain
        accessible when required. Our fee is £35 + VAT per annum and remains payable for as long as the service is required.
      </p>
      <CheckboxField label="I wish to use the document storage service on the terms set out above."
        checked={value.storageService} onChange={(v) => set("storageService", v)} testId="disc-storage" />

      {(variant === "trust" || variant === "lpa" || variant === "will") && (
        <>
          <SubHead>Annual minutes (trust arrangements)</SubHead>
          <p className="text-sm text-brand-muted leading-relaxed mb-2">
            Where required by the structure of your estate planning, annual minutes confirm the trust has been reviewed
            and record any decisions taken. We can prepare these each year for £100 + VAT per annum.
          </p>
          <CheckboxField label="I wish to use the Annual Minutes service on the terms set out above."
            checked={value.annualMinutes} onChange={(v) => set("annualMinutes", v)} testId="disc-annual-minutes" />
        </>
      )}

      <p className="text-xs text-brand-muted mt-4 pt-3 border-t border-brand-line">
        By submitting this instruction I/we confirm that we have read and understood the information set out above and,
        where applicable, agree to proceed with the selected services.
      </p>
    </div>
  );
}
